import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import useStyle from "./style/stylePopup";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useData } from "../../../components/firebase/DataProvider";
// import { useEffect } from "react";
// import { useState } from "react";

function DialogPopup({
  open,
  handleClose,
  data,
  setOpenFlashSale,
  openFlashSale,
}) {
  const { promo } = useData();
  const classes = useStyle();
  const history = useHistory();
  const [load, setLoad] = useState(true);
  useEffect(() => {
    setTimeout(() => setLoad(false), 1500);
  }, []);

  const handleClick = (item) => async () => {
    switch (item?.target_type) {
      case "kategori3":
        history.push(
          `/kategori/kategori3/${item?.target_name}/${item?.target_id}`
        );
        break;
      case "brand":
        history.push(`/kategori/brand/${item?.target_name}/${item?.target_id}`);
        break;
      case "produk":
        history.push(`/produk/${item?.target_name}/${item?.target_id}`);
        break;
      case "promo":
        if (item?.target_id === "flashsale") {
          const flashsaleRef = promo?.filter((doc) => doc.flash_sale === true);
          handleClose();
          return flashsaleRef.length ? setOpenFlashSale(true) : null;
        }
        break;
      case "webview":
        window.open(`${item?.target_id}`);
        break;
      default:
        break;
    }
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.dialog}
      PaperProps={{
        style: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <DialogContent className={classes.dialogContent}>
        <div style={{ width: "45vh" }}>
          {!load ? (
            <div style={{ position: "absolute", right: 0 }}>
              <IconButton
                style={{ backgroundColor: "white" }}
                size="small"
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          ) : null}
          <div style={{ padding: "10px" }}>
            <img
              loading="lazy"
              onClick={handleClick(data?.data)}
              style={{
                objectFit: "cover",
                width: "100%",
                borderRadius: "8px",
              }}
              // className={classes.hero}
              src={data?.imageUrl}
              alt="gambar"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default DialogPopup;
